/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Paket_OkInputs */

const en_tut_paket_ok = /** @type {(inputs: Tut_Paket_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The plan card switches to the new plan and the transaction appears in the **Riwayat pembayaran** table.`)
};

const id_tut_paket_ok = /** @type {(inputs: Tut_Paket_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kartu paket berganti ke paket baru dan transaksinya muncul di tabel **Riwayat pembayaran**.`)
};

/**
* | output |
* | --- |
* | "The plan card switches to the new plan and the transaction appears in the **Riwayat pembayaran** table." |
*
* @param {Tut_Paket_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_paket_ok = /** @type {((inputs?: Tut_Paket_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Paket_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_paket_ok(inputs)
	return en_tut_paket_ok(inputs)
});